import { render, staticRenderFns } from "./InformationComponent.vue?vue&type=template&id=22c82bbe&scoped=true"
import script from "./InformationComponent.vue?vue&type=script&lang=js"
export * from "./InformationComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationComponent.vue?vue&type=style&index=0&id=22c82bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c82bbe",
  null
  
)

export default component.exports